import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Alert from 'component/utils/Alert'

class UseConsumeJustificationForm extends Component {
  state = {
    alert: {
      show: false,
      message: '',
    },
  }

  static propTypes = {
    fields: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    justification: PropTypes.object,
    updateJustification: PropTypes.func,
  }

  handleAlert = (message) => {
    this.setState((prevState) => ({
      alert: {
        show: !prevState.alert.show,
        message: message || '',
      },
    }))
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { onSubmit, translate, justification } = this.props

    if (
      !justification.dsUseConsumeJustification ||
      justification.dsUseConsumeJustification.length === 0
    ) {
      return
    }
    if (justification.dsUseConsumeJustification.length > 250) {
      let msg = translate('use.consume.disapproval.dsJustificationMaxSize')
      msg = msg.replace('#', '250')
      this.handleAlert(msg)
      return
    }
    onSubmit(justification)
  }

  handleChange = (e) => {
    const { updateJustification, justification } = this.props
    updateJustification({
      ...justification,
      dsUseConsumeJustification: e.target.value,
    })
  }

  handleClean = () => {
    const { updateJustification } = this.props
    updateJustification({ dsUseConsumeJustification: '' })
  }

  render() {
    const { translate, fields, justification } = this.props

    const { alert } = this.state

    return (
      <form onSubmit={this.handleSubmit}>
        <Row>
          <Col lg={6} lgOffset={3} md={6} mdOffset={3} sm={12} xs={12}>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Field {...fields.dsUseConsumeJustification}>
                <Input
                  id='dsUseConsumeJustification'
                  {...fields.dsUseConsumeJustification.input}
                  value={justification.dsUseConsumeJustification}
                  onChange={(e) => this.handleChange(e)}
                />
              </Field>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                type='submit'
                className='button button-primary button-full'
              >
                {justification.idUseConsumeJustification
                  ? translate('use.consume.justification.update')
                  : translate('use.consume.justification.register')}
              </button>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                type='button'
                className='button-hollow button-hollow-danger button-full align-center'
                onClick={() => this.handleClean()}
              >
                {translate('use.consume.justification.clean')}
              </button>
            </Col>
          </Col>
        </Row>

        {alert.show && (
          <Alert
            handleAlert={this.handleAlert}
            text={translate(alert.message)}
            translate={translate}
            textButton={translate('irc.gama.closeAlert')}
            preventDefault
            size='sm'
          />
        )}
      </form>
    )
  }
}

const fields = ['dsUseConsumeJustification']

export default Form({ fields })(UseConsumeJustificationForm)

export { UseConsumeJustificationForm }
